import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class RecSessionService {
    static async getRecSessionsAsync(projectId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/rec-session`);
        return response.items || response || [];
    }

    static async createRecSessionAsync(projectId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/rec-session`, body);
    }

    static async uploadTrackAsync(projectId, recSessionId, formData, queryParams) {
        return await NetworkService.postMultiPartAsync(
            `${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}/track`,
            formData,
            queryParams
        );
    }
}
